import { roundCents } from "../money.js";
function toMs(v) {
    if (typeof v === "number")
        return v;
    if (v instanceof Date)
        return v.getTime();
    return new Date(v).getTime();
}
/**
 * hours = (departed - arrived) / 3600000
 * billable = max(0, hours - freeHours)
 * pay = roundCents(billable * rate)
 */
export function detentionPay(input) {
    const hours = (toMs(input.departedAt) - toMs(input.arrivedAt)) / 3_600_000;
    const billableHours = Math.max(0, hours - input.freeHours);
    const payCents = roundCents(billableHours * input.rateCentsPerHour);
    return { hours, billableHours, payCents };
}
//# sourceMappingURL=detention.js.map